module.exports = __webpack_public_path__ + "static/media/ic_user_group_customize.09c32363.svg";